export const environment = {
  production: true,
  // apiUrl: 'http://127.0.0.1:8000/api',
  apiUrl: 'https://demo-api.buildxy.com/api',
  baseUrl: 'https://demo-api.buildxy.com/',
  storageUrl: 'https://demo-api.buildxy.com/api/storage/',
  apiKey: 'AIzaSyA9Xi-EcZj4TrvdVQSvpheBXdKldXQhRZU',
  localApi: 'https://demo-api.buildxy.com/api',

  google_recaptcha_site_key: '6Lejnq8qAAAAAFhHsSAkQ19Ay1xh6VkguwWYhBc-',
};
